import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

const Meta = ({
  title,
  keywords,
  description,
  image,
  siteName,
  appId,
  host,
  url,
}) => (
  <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={`${host}${image}`} />}
      {url && <meta property="og:url" content={`${url}`} />}
      {title && <meta name="twitter:card" content={title} />}

      {siteName && <meta property="og:site_name" content={siteName} />}
      {title && <meta name="twitter:image:alt" content={title} />}

      {appId && <meta property="fb:app_id" content={appId} />}
      {url && <meta name="twitter:site" content={`${url}`} />}
    </Helmet>
);

const mapState = state => ({
  host: state.host,
  url: state.url,
});

export default connect(mapState)(Meta);



// WEBPACK FOOTER //
// ./src/components/modules/Meta/Meta.js